import React, { FC, useEffect, useRef } from 'react'
import { Crepe } from '@milkdown/crepe'

export interface MilkdownEditorProps {
  defaultValue: string
  onChange?: (markdown: string) => void
}

const MilkdownEditor: FC<MilkdownEditorProps> = ({
  defaultValue,
  onChange,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const crepeRef = useRef<Crepe | null>(null)
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const crepe = new Crepe({
      root: el,
      defaultValue,
    })

    crepe.on((listener: any) => {
      listener.markdownUpdated((_ctx: any, markdown: string) => {
        onChangeRef.current?.(markdown)
      })
    })

    crepeRef.current = crepe
    crepe.create()

    return () => {
      crepe.destroy()
      crepeRef.current = null
    }
  }, [])

  return <div ref={containerRef} />
}

export default MilkdownEditor
